import React, {Component} from 'react'
import { Link } from 'react-router-dom'

import './jobs-styles.css'

export default class JobListing extends Component {

  render(){
    var str = this.props.title;
    str = str.replace(/\s+/g, '-').toLowerCase();
    return(
      <div>
        <div>
          <Link to={{pathname:'/jobs/'+str, search:this.props.id}} className="postingTitle">{this.props.title}</Link>
          <p className="postingSubtitle">{this.props.location}</p>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Views/Jobs/JobListing.js